module.exports = __webpack_public_path__ + "static/media/1-Madit.b08536f6.jpg";